export const BRAND_OWNER_DELIMITER = '|brand_owner:';
export const BRAND_OWNER_GROUP_PREFIX = 'null|brand_owner:';
export const BRAND_OWNER_KEY = 'brand_owner_name';
export const BRAND_KEY = 'brand_name';
